import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconImac"><Path d="M21.25 13.25H2.75M21.25 13.25V7.75C21.25 5.54086 19.4591 3.75 17.25 3.75H6.75C4.54086 3.75 2.75 5.54086 2.75 7.75V13.25M21.25 13.25C21.25 15.4591 19.4591 17.25 17.25 17.25H6.75C4.54086 17.25 2.75 15.4591 2.75 13.25M9.75 17.25H14.25V21.25H9.75V17.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconImac;
